module.exports = __webpack_public_path__ + "static/media/postcardDisabled.dccd456b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/postcardDisabled.svg
// module id = 1208
// module chunks = 70